'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$99() {
  this.bJR = null;
  this.bJS = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$99 as $c_Lpresto_TwoFactorAuthView$$anon$99 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$99.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$99;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$99() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$99 as $h_Lpresto_TwoFactorAuthView$$anon$99 };
$h_Lpresto_TwoFactorAuthView$$anon$99.prototype = $p;
$p.P = (function() {
  if ((!this.bJS)) {
    this.bJR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T5($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bJS = true;
  }
  return this.bJR;
});
var $d_Lpresto_TwoFactorAuthView$$anon$99 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$99, "presto.TwoFactorAuthView$$anon$99", ({
  TD: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$99 as $d_Lpresto_TwoFactorAuthView$$anon$99 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$99.js.map
